import { getLanguageCode } from "web/Layout/Translations/LanguageWrapper";

const getOriginalValue = (data: any, key: string | undefined = "name") => {
    if (!data?.hasOwnProperty(key)) {
        return "";
    }

    const language = getLanguageCode();
    const isEn = ["en_GB", "en", "EN"].includes(language);

    if (isEn && data?.original_values?.[key]) {
        return data.original_values[key];
    }
    return data[key];
};

export default getOriginalValue;
